<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="群发信息管理"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          <el-form-item label="发送类型">
            <el-select v-model="params.SendType" placeholder="请选择发送类型" clearable>
              <el-option label="即时发送" :value="1"></el-option>
              <el-option label="定时发送" :value="0"></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="内容类型">
            <el-select v-model="params.SendType" placeholder="请选择内容类型" clearable>
              <el-option label="图文" :value="1"></el-option>
              <el-option label="文字" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送内容">
            <el-input v-model="params.SendContent" placeholder="请输入发送内容" clearable />
          </el-form-item>
           <el-form-item label="对象标签">
            <el-input v-model="params.SendLabel" placeholder="请输入发送对象标签" clearable />
          </el-form-item>
           <el-form-item label="状态">
            <el-select v-model="params.SendType" placeholder="请选择状态" clearable>
              <el-option label="发送成功" :value="1"></el-option>
              <el-option label="未发送" :value="0"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="注册时间">
            <el-date-picker
              size="mini"
              v-model.trim="params.RegStarttime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
            <span style="margin:0 10px;">-</span>
            <el-date-picker
              size="mini"
              v-model.trim="params.RegEndtime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
          </el-form-item>

        </template>
        <template slot="table">
          
          <el-table-column prop="SendType" label="群发类型" />
          <el-table-column prop="ContentType" label="内容类型" />
          <el-table-column prop="SendLabel" label="发送对象标签" />
          <el-table-column prop="SendTime" label="发送时间" />
          <el-table-column prop="EndTime" label="完成时间" />
          
          <el-table-column prop="State" width="80px" label="状态" align="center">
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.State == 1">发送成功</el-tag>
              <el-tag type="danger" v-else>未发送</el-tag>
            </template>
          </el-table-column>
           <el-table-column label="头像" align="center" width="145px">
            <template slot-scope="{row}">
              <el-image v-if="row.ProfilePhoto" :src="'/api' + row.ProfilePhoto" style="width:120px;margin-top:8px;"></el-image>
            </template>
          </el-table-column>
           <el-table-column prop="RegisterTime" label="注册时间" min-width="160px"/>

     <!--       <el-table-column prop="RegisterTime" label="注册时间">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.RegisterTime)}}
          </template>
        </el-table-column> -->
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
       // api: require("@/api/person/persongrade").default,
        params: {
         SendType: "",
         SendContent: "",
         SendLabel: "",
          State: null,
        },
        Grades: [],
      };
    },
   mounted() {
    this.grade_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Grades = res.Data;
      }
    })
  },
    methods: {

    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{SendType:"即时发送",ContentType:"图文",SendLabel:"黄金会员",SendTime:"2024-09-10 15:01:03",EndTime:"2024-09-10 15:03:03",State:1},{SendType:"定时发送",ContentType:"文本",SendLabel:"家庭主妇",SendTime:"2024-09-11 11:00:00",EndTime:"",State:0}]});
      })
    },
     
    },
  };
  </script>